// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Badge" (12125:150119). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const badgeContract = {
    component: 'Badge',
    nodeId: '12125:150119',
    section: '[Web] Primitives',
    composes: [] as readonly ContractComposition[],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [
        {
            note: 'primaryAxisAlignItems CENTER on a row that hugs — no slack to align in, so the file states an alignment it does not draw',
            count: 5,
            property: 'primaryAxisAlignItems',
            stated: 'CENTER',
        },
    ] as readonly ContractDisagreement[],
    textStyleIds: ['S:6f95766c626639c89a4378f1339bf1523ebeac7e,'],
    props: {
        text: { kind: 'text' },
        variant: { kind: 'enum', values: ['warning', 'caution', 'neutral', 'critical', 'success'] },
    },
    variants: {
        'variant=caution': {
            container: 'bg-status-caution rounded-common px-xs gap-s items-center',
            label: 'text-content-inverted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                '#value': 'text-content-inverted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                '#value': 'S:6f95766c626639c89a4378f1339bf1523ebeac7e,',
            } as Record<string, string>,
            composes: [],
        },
        'variant=critical': {
            container: 'bg-status-critical rounded-common px-xs gap-s items-center',
            label: 'text-content-default text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                '#value': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                '#value': 'S:6f95766c626639c89a4378f1339bf1523ebeac7e,',
            } as Record<string, string>,
            composes: [],
        },
        'variant=neutral': {
            container: 'bg-status-neutral rounded-common px-xs gap-s items-center',
            label: 'text-content-inverted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                '#value': 'text-content-inverted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                '#value': 'S:6f95766c626639c89a4378f1339bf1523ebeac7e,',
            } as Record<string, string>,
            composes: [],
        },
        'variant=success': {
            container: 'bg-status-success rounded-common px-xs gap-s items-center',
            label: 'text-content-inverted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                '#value': 'text-content-inverted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                '#value': 'S:6f95766c626639c89a4378f1339bf1523ebeac7e,',
            } as Record<string, string>,
            composes: [],
        },
        'variant=warning': {
            container: 'bg-status-warning rounded-common px-xs gap-s items-center',
            label: 'text-content-inverted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                '#value': 'text-content-inverted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                '#value': 'S:6f95766c626639c89a4378f1339bf1523ebeac7e,',
            } as Record<string, string>,
            composes: [],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
